import { IconButton } from '@chakra-ui/react';
import { useState } from 'react';
import { IoRefreshOutline } from 'react-icons/io5';
import type { DataCollectionContextProps } from './DataCollection.types';

const MIN_SPIN_DURATION_MS = 500;
export function RefreshButton<T extends Record<string, unknown>>({ useDataCollection }: { useDataCollection: () => DataCollectionContextProps<T> }) {
	const { refetchData } = useDataCollection();
	const [isSpinning, setIsSpinning] = useState<boolean>(false);

	return (
		<IconButton
			onClick={() => {
				refetchData();
				setIsSpinning(true);
				setTimeout(() => setIsSpinning(false), MIN_SPIN_DURATION_MS);
			}}
			variant="outlineSecondary"
		>
			<span className={isSpinning ? 'spin' : ''} style={{ paddingBottom: '2px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
				<IoRefreshOutline />
			</span>
		</IconButton>
	);
}
